import { defineNuxtPlugin } from '#app';

// Product Fruits integration is currently disabled. The previous implementation
// is preserved in git history (see commit history for this file). When re-enabling,
// move the heavy imports (`product-fruits`, `js-sha3`) into the activation path
// so the bundle cost is only paid where the SDK actually runs.
export default defineNuxtPlugin(() => {});
